module.exports = __webpack_public_path__ + "img/list.b32359cc.svg";